import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IFormWrapperDeps, TFormWrapperPropsDesktop } from './models';
import styles from './styles.css';
import { FormWrapper as Component } from './component';

export const FormWrapperDesktop = createWidget<IFormWrapperDeps, TFormWrapperPropsDesktop>({
    styles,
})(Component);
